import styles from '../calendar.module.css'
import { useInlineSettings } from '../../../contexts/InlineSettingsContext'
import React, { useCallback, useEffect } from 'react'
import DatePicker from 'react-datepicker'
import { Box } from '@chakra-ui/core'
import { useDatePickerLocale } from 'hooks/useDatePickerLocale'

interface DatePickerComponentProps {
  isOpen: boolean
  onClose: () => void
  selectedDate: Date | null
  handleChange: (date: Date | null) => void
  minDate: Date
  useCustomTranslations?: boolean
}

export const DeadlinePickerComponent: React.FC<DatePickerComponentProps> = ({
  isOpen,
  onClose,
  selectedDate,
  handleChange,
  minDate,
  useCustomTranslations = true,
}) => {
  const inlineSettings = useInlineSettings()
  const datePickerLocale = useDatePickerLocale(useCustomTranslations)

  const scrollToLastSubtask = useCallback(() => {
    const scrollContainer = document.querySelector('[data-scroll-container]') as HTMLDivElement

    if (!scrollContainer) return

    scrollContainer.scrollTo({
      top: scrollContainer.scrollHeight,
      behavior: 'smooth',
    })
  }, [])

  useEffect(() => {
    if (isOpen && !inlineSettings) {
      scrollToLastSubtask()
    }
  }, [isOpen, inlineSettings, scrollToLastSubtask])

  return isOpen ? (
    <Box
      className={styles.wrapper}
      pos={inlineSettings ? 'relative' : 'absolute'}
      zIndex={inlineSettings ? 1 : 9999}
      top={inlineSettings ? undefined : '80px'}
      w={inlineSettings ? '100%' : '65%'}
      left={inlineSettings ? undefined : '50%'}
      transform={inlineSettings ? undefined : 'translateX(-50%)'}
    >
      <DatePicker
        calendarClassName={styles.calendar}
        open
        selected={selectedDate}
        onChange={handleChange}
        dateFormat="dd/MM/yy HH:mm"
        timeFormat="HH:mm"
        locale={datePickerLocale}
        showMonthDropdown
        showYearDropdown
        minDate={minDate}
        inline
        onClickOutside={onClose}
      />
    </Box>
  ) : null
}
